import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  max-width: 602px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: var(--rounding-radius-xxxl, 48px);
  background: var(--Points, #c8ff26);
  box-shadow: 0px 0px 40px 0px #c8ff26;
  padding: var(--spacing-space-16, 16px) var(--spacing-space-32, 32px)
    var(--spacing-space-16, 16px) var(--spacing-space-16, 16px);

  p,
  .body,
  .caption,
  .action {
    color: #000;
  }
  p.secondary {
    color: rgba(66, 61, 60, 0.64);
  }
  .pic {
    width: 64px;
    height: 64px;
    object-fit: contain;
  }

  .body {
    font-variation-settings: "wght" 500;
  }

  @media (max-width: 768px) {
    border-radius: var(--rounding-radius-xxl, 32px);
    padding: var(--spacing-space-32, 32px);
    flex-direction: column;
    justify-content: center;
    p {
      text-align: center;
    }
  }
`;
